if (!customElements.get('lookbook-gallery')) {
  class LookbookGallery extends HTMLElement {
    constructor() {
      super();
  
      this.masonryInstance = null;
  
      this.init();
    }

    async checkInstance() {
      return new Promise((resolve, reject) => {
        const lookbookGalleryInstances = document.querySelectorAll('lookbook-gallery');

        /* check if we are in first instance, otherwise return */
        if (!lookbookGalleryInstances[0].isSameNode(this)) {
          /* we need to append every .grid__item to the first instance */
          const firstInstance = lookbookGalleryInstances[0];
          const gridItems = this.querySelectorAll('.grid__item');
  
          gridItems.forEach(gridItem => {
            firstInstance.appendChild(gridItem);
          });
          
          this.closest('.shopify-section').remove();

          resolve(false);
        } else {
          resolve(true);
        }
      });
    }
  
    async init() {
      if (!await this.checkInstance()) {
        return;
      }

      this.masonryInstance = new Masonry(this, {
        itemSelector: '.grid__item'
      });

      Fancybox.bind("[data-fancybox]", {
        hash: false,
        backFocus: false,
        thumbs: {
          autoStart: true,
          hideOnClose: true
        }
      });
    }
  }

  customElements.define('lookbook-gallery', LookbookGallery);
}